import { render, staticRenderFns } from "./CommerceInfo.vue?vue&type=template&id=705d93fd&scoped=true&lang=pug&"
import script from "./CommerceInfo.vue?vue&type=script&lang=js&"
export * from "./CommerceInfo.vue?vue&type=script&lang=js&"
import style0 from "./CommerceInfo.vue?vue&type=style&index=0&id=705d93fd&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "705d93fd",
  null
  
)

export default component.exports